import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconArrow1Down = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 23.844 13.91'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M11.923,13.916 C11.645,13.916 11.379,13.800 11.191,13.594 L0.284,1.677 C-0.086,1.272 -0.059,0.644 0.345,0.274 C0.749,-0.097 1.376,-0.069 1.746,0.335 L11.923,11.453 L22.099,0.335 C22.468,-0.069 23.097,-0.097 23.500,0.274 C23.904,0.644 23.931,1.272 23.561,1.677 L12.654,13.594 C12.466,13.800 12.201,13.916 11.923,13.916 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconArrow1Down.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
